export const LINK_ACCESSO = 
{
	BREADCRUMBS: "link/accesso/breadcrumbs",
	TITOLO: "link/accesso/titolo",
	DESCRIZIONE: "link/accesso/descrizione",
	TITOLO_NO_SERVIZIO: "link/accesso/titolo_no_servizio",
	DESCRIZIONE_NO_SERVIZIO: "link/accesso/descrizione_no_servizio",
	SPID_TITOLO: "link/accesso/spid/titolo",
	SPID_DESCRIZIONE: "link/accesso/spid/descrizione",
	SPID_COME_RICHIEDERE: "link/accesso/spid/come_richiedere",
	CIE_TITOLO: "link/accesso/cie/titolo",
	CIE_DESCRIZIONE: "link/accesso/cie/descrizione",
	CIE_COME_RICHIEDERE: "link/accesso/cie/come_richiedere",
	CHIAVE_WEB_TITOLO: "link/accesso/chiave_web/titolo",
	CHIAVE_WEB_DESCRIZIONE: "link/accesso/chiave_web/descrizione",
	CHIAVE_WEB_CAMPO_CHIAVE: "link/accesso/chiave_web/campo_chiave",
	CHIAVE_WEB_FORMATO_CHIAVE_NON_CORRETTO: "link/accesso/chiave_web/formato_chiave_non_corretto",
	CHIAVE_WEB_BOTTONE_CONFERMA: "link/accesso/chiave_web/bottone_conferma",
};

export const LINK_BASE = 
{
	HEADER: "link/base/header",
	FOOTER: "link/base/footer",
	INTERMEDIARIO: "link/base/intermediario",
	LINGUE: "link/base/lingue",
	VALUTAZIONE: "link/base/valutazione",
};

export const LINK_RITORNO_SPID = 
{
	ERRORE_ACCESSO_TITOLO: "link/ritorno_spid/errore_accesso/titolo",
	ERRORE_ACCESSO_TORNA_HOME: "link/ritorno_spid/errore_accesso/torna_home",
};

export const LINK_FORM_GENERICA = 
{
	MODIFICA: "link/form_generica/modifica",
	CONFERMA: "link/form_generica/conferma",
	ANNULLA: "link/form_generica/annulla",
	CAMPO_OBBLIGATORIO: "link/form_generica/campo_obbligatorio",
};

export const LINK_FORM_ANAGRAFICA = 
{
	COGNOME: "link/form_anagrafica/cognome",
	NOME: "link/form_anagrafica/nome",
	CODICE_FISCALE: "link/form_anagrafica/codice_fiscale",
	TELEFONO: "link/form_anagrafica/telefono",
	EMAIL: "link/form_anagrafica/email",
	NASCITA_TITOLO: "link/form_anagrafica/nascita/titolo",
	NASCITA_DATA: "link/form_anagrafica/nascita/data",
	RESIDENZA_TITOLO: "link/form_anagrafica/residenza/titolo",
};

export const LINK_FORM_INDIRIZZO = 
{
	NAZIONE: "link/form_indirizzo/nazione",
	COMUNE: "link/form_indirizzo/comune",
	COMUNE_ESTERO: "link/form_indirizzo/comune_estero",
	TIPO_STRADA: "link/form_indirizzo/tipo_strada",
	DENOMINAZIONE_STRADA: "link/form_indirizzo/denominazione_strada",
	CIVICO: "link/form_indirizzo/civico",
	INSERISCI_CAP_COMUNE: "link/form_indirizzo/inserisci_cap_comune",
};

export const LINK_FORM_PATENTE = 
{
	CATEGORIA: "link/form_patente/categoria",
	NUMERO: "link/form_patente/numero",
	DATA_RILASCIO: "link/form_patente/data_rilascio",
	ENTE_RILASCIO: "link/form_patente/ente_rilascio",
	ENTE_RILASCIO_PROVINCIA: "link/form_patente/ente_rilascio_provincia",
	DATA_SCADENZA: "link/form_patente/data_scadenza",
	DATA_PRIMA_EMISSIONE: "link/form_patente/data_prima_emissione",
};

export const LINK_FORM_CARICA_FILE = 
{
	DA_CARICARE: "link/form_carica_file/da_caricare",
	CARICAMENTO_EFFETTUATO: "link/form_carica_file/caricamento_effettuato",
	FORMATI_VALIDI: "link/form_carica_file/formati_validi",
	DIMENSIONE_MAX: "link/form_carica_file/dimensione_max",
	FILE_SCARICATO: "link/form_carica_file/file_scaricato",
	BOTTONE_ELIMINA: "link/form_carica_file/bottone_elimina",
	BOTTONE_CARICA: "link/form_carica_file/bottone_carica",
	BOTTONE_SCARICA: "link/form_carica_file/bottone_scarica",
};

export const LINK_SERVIZI = 
{
	TITOLO: "link/servizi/titolo",
	DESCRIZIONE: "link/servizi/descrizione",
	DESCRIZIONE_NO_SERVIZIO: "link/servizi/descrizione_no_servizio",
	PASS_TITOLO: "link/servizi/pass/titolo",
	PASS_DESCRIZIONE: "link/servizi/pass/descrizione",
	PASS_URL: "link/servizi/pass/url",
	PASS_ATTIVO: "link/servizi/pass/attivo",
	DATICONDUCENTE_TITOLO: "link/servizi/datiConducente/titolo",
	DATICONDUCENTE_DESCRIZIONE: "link/servizi/datiConducente/descrizione",
	DATICONDUCENTE_URL: "link/servizi/datiConducente/url",
	DATICONDUCENTE_ATTIVO: "link/servizi/datiConducente/attivo",
	FRONTOFFICE_TITOLO: "link/servizi/frontoffice/titolo",
	FRONTOFFICE_DESCRIZIONE: "link/servizi/frontoffice/descrizione",
	FRONTOFFICE_URL: "link/servizi/frontoffice/url",
	FRONTOFFICE_ATTIVO: "link/servizi/frontoffice/attivo",
	BREADCRUMBS: "link/servizi/breadcrumbs",
	VAI_ALLA_PAGINA: "link/servizi/vai_alla_pagina",
	SERVIZIO_ONLINE: "link/servizi/servizio_online",
};

